import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  G4_P5_S1_Tab1Title: {
    id: `guide04.page05.slide01.tab1Title`,
  },
  G4_P5_S1_Tab2Title: {
    id: `guide04.page05.slide01.tab2Title`,
  },
  G4_P5_S1_Hs_PhotoCaption: {
    id: `guide04.page05.slide01.hs.photoCaption`,
  },
  G4_P5_S1_Hs_Item1: {
    id: `guide04.page05.slide01.hs.item1`,
  },
  G4_P5_S1_Hs_Item2: {
    id: `guide04.page05.slide01.hs.item2`,
  },
  G4_P5_S1_Hs_Item3: {
    id: `guide04.page05.slide01.hs.item3`,
  },
  G4_P5_S1_Hs_Item4: {
    id: `guide04.page05.slide01.hs.item4`,
  },
  G4_P5_S1_Hs_Item5: {
    id: `guide04.page05.slide01.hs.item5`,
  },
  G4_P5_S1_Cinema_PhotoCaption: {
    id: `guide04.page05.slide01.cinema.photoCaption`,
  },
  G4_P5_S1_Cinema_Item1: {
    id: `guide04.page05.slide01.cinema.item1`,
  },
  G4_P5_S1_Cinema_Item2: {
    id: `guide04.page05.slide01.cinema.item2`,
  },
  G4_P5_S1_Cinema_Note: {
    id: `guide04.page05.slide01.cinema.note`,
  },
});
